module.exports = __webpack_public_path__ + "1d1d2ccd7f0a26e47dc19448ba7063df.svg";